import { render, staticRenderFns } from "./goodsdetail.vue?vue&type=template&id=8e766b5c&scoped=true"
import script from "./goodsdetail.vue?vue&type=script&lang=js"
export * from "./goodsdetail.vue?vue&type=script&lang=js"
import style0 from "./goodsdetail.vue?vue&type=style&index=0&id=8e766b5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e766b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e766b5c')) {
      api.createRecord('8e766b5c', component.options)
    } else {
      api.reload('8e766b5c', component.options)
    }
    module.hot.accept("./goodsdetail.vue?vue&type=template&id=8e766b5c&scoped=true", function () {
      api.rerender('8e766b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/goodsdetail.vue"
export default component.exports